export const ICE_MACHINE_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/#organization",
   "name": "Everest Indústria e Comércio",
   "url": "https://everest.ind.br/pt",
   "logo": {
    "@type": "ImageObject",
    "url": "https://everest.ind.br/assets/images/logo-slogan.png"
   }
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest: Qualidade em Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   }
  },
  {
   "@type": "CollectionPage",
   "@id": "https://everest.ind.br/pt/produto/maquinas-de-gelo#webpage",
   "url": "https://everest.ind.br/pt/produto/maquinas-de-gelo",
   "name": "Máquinas de Gelo Everest",
   "description": "Produza gelo filtrado em cubos com mais eficiência no seu negócio com a máquina de gelo Everest com armazenamento, ideal para reduzir custos e aumentar a produção.",
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/produto/maquinas-de-gelo#catalog"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/produto/maquinas-de-gelo#breadcrumb"
   }
  },
  {
   "@type": "OfferCatalog",
   "@id": "https://everest.ind.br/pt/produto/maquinas-de-gelo#catalog",
   "name": "Catálogo de Máquinas de Gelo Everest",
   "itemListElement": [
    {
     "@type": "Product",
     "name": "EGC 50",
     "image": "https://assets.everest.ind.br/images/EGC_50.diagonal-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "50kg/dia"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Compacta"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "7800",
      "highPrice": "9200",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "EGC 75",
     "image": "https://assets.everest.ind.br/images/EGC_75_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "75kg/dia"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Compacta"
      }
     ],
     "offers": {
      "@type": "Offer",
      "price": "10900",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "EGC 150",
     "image": "https://assets.everest.ind.br/images/EGC_150_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "150kg/dia"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Compacta"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "15700",
      "highPrice": "17000",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "EGC 75M",
     "image": "https://assets.everest.ind.br/images/EGC_75M_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "75kg/dia"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Modular"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "9200",
      "highPrice": "10000",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "75M/70",
     "image": "https://assets.everest.ind.br/images/EGC_75M_70_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "75kg + 70kg"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Modular"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "11300",
      "highPrice": "13100",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "75M/140",
     "image": "https://assets.everest.ind.br/images/EGC_75M_140_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "75kg + 140kg"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Modular"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "12200",
      "highPrice": "12800",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "EGC 150M",
     "image": "https://assets.everest.ind.br/images/EGC_150M_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "150kg/dia"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Modular"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "14500",
      "highPrice": "15300",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "150M/140",
     "image": "https://everest.ind.br/images/150m-140.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "150kg + 140kg"
      },
      {
       "@type": "PropertyValue",
       "name": "Tipo",
       "value": "Modular"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "17800",
      "highPrice": "18900",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "150M/250",
     "image": "https://assets.everest.ind.br/images/EGC_150M_250_f-min_koFRba6.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "150kg + 250kg"
      }
     ],
     "offers": {
      "@type": "Offer",
      "price": "19200",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "225M/250",
     "image": "https://assets.everest.ind.br/images/EGC_225M_250_f-min.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "~225kg"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "22000",
      "highPrice": "26000",
      "priceCurrency": "BRL"
     }
    },
    {
     "@type": "Product",
     "name": "300M/250",
     "image": "https://assets.everest.ind.br/images/EGC_300M_250.original.jpg",
     "additionalProperty": [
      {
       "@type": "PropertyValue",
       "name": "Produção",
       "value": "~300kg"
      }
     ],
     "offers": {
      "@type": "AggregateOffer",
      "lowPrice": "28000",
      "highPrice": "35000",
      "priceCurrency": "BRL"
     }
    }
   ]
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/produto/maquinas-de-gelo#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Máquinas de Gelo",
     "item": "https://everest.ind.br/pt/produto/maquinas-de-gelo"
    }
   ]
  }
 ]
}
